"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_URL = exports.API_URL = exports.COLUMNS_THAT_FORCE_RELOAD = exports.HEADER_NAMES_CR = exports.HEADER_NAMES = exports.COL_TO_PAYLOAD_KEY_MAP = void 0;
exports.COL_TO_PAYLOAD_KEY_MAP = {
    'Routing Number': 'routing_number',
    'Category': 'category_id',
    'Subcategory': 'subcategory_id',
    'Record Type': 'record_type',
    'No': 'number',
    'Who': 'who',
    'What to Store': 'what',
    'Min or Max': 'min_max',
    'Retention': 'retention',
    'Period': 'period',
    'From': 'from',
    'Legal Reference': 'legal_reference',
    'Legal Reference link': 'legal_link',
    'Taxonomy': 'taxonomy',
    'Action': 'action',
};
exports.HEADER_NAMES = ['Jurisdiction', 'Routing Number', 'Category', 'Subcategory', 'Record Type', 'No', 'Who', 'What to Store', 'Min or Max', 'Retention', 'Period', 'From', 'Legal Reference', 'Legal Reference link', 'Action'];
exports.HEADER_NAMES_CR = ['Jurisdiction', 'Routing Number', 'Category', 'Subcategory', 'Record Type', 'No', 'Who', 'What to Store', 'Min or Max', 'Retention', 'Period', 'From', 'Legal Reference', 'Legal Reference link'];
exports.COLUMNS_THAT_FORCE_RELOAD = ['Routing Number', 'Category', 'Subcategory', 'Record Type'];
exports.API_URL = window.API_URL;
exports.BASE_URL = window.BASE_URL;
